import listLoader from '@/mixin/list-loader';
export default {
  name: 'ListViewCpt',
  mixins: [listLoader],
  props: {
    request: {
      type: [Object, Function],
      require: true
    },
    requestParameter: {
      type: [Object],
      default() {
        return {};
      }
    },
    resultDataKey: {
      type: [String],
      default() {
        return '';
      }
    },
    resultDataFormatter: {
      type: [Function]
    },
    immediateCheck: {
      type: Boolean,
      default: true
    },
    isPaging: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchForm: {
        ...this.requestParameter
      }
    };
  },
  created() {
    if (!this.isPaging) {
      this.listPagination.pageSize = 1000000000;
    }
  },
  // activated() {
  //   this.initListData()
  // },
  mounted() {
    if (this.immediateCheck) {
      this.initListData();
    }
  },
  methods: {
    onSearchBefore() {
      this.searchForm = {
        ...this.requestParameter
      };
    },
    initListData() {
      this.onSearch();
    }
  }
};